
import './App.css';
import Header from './Components/Header';
import Home from './Components/Home'

function App() {
  return (
    <div>
      <Header />
      <Home />
     

    </div>
  );
}

export default App;
